import { Observable } from "rxjs/Observable";
import { Injectable } from "@angular/core";
import { RouterStateSnapshot, Router } from "@angular/router";
import { Observer } from "rxjs/Observer";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class PermissionService {

    private static userHasPermissionUrl: string = '/api/permissions/userHasPermission';
    private static getUserPermissionsUrl: string = '/api/permissions/getUserPermissions';
    public permissionNames = new Array<string>();

    constructor(
        private http: HttpClient,
        private router: Router
    ) { }

    public userHasPermission(permissionName: string): boolean {
        return this.permissionNames.indexOf(permissionName) > -1;
    }

    public getPermissions(observer: Observer<boolean>): Observable<Array<any>> {
        let self: PermissionService = this;
        let observable = this.http.get<Array<any>>(PermissionService.getUserPermissionsUrl).share();
        observable.subscribe(permissions => self.permissionNames = permissions.map(x => x.PermissionName), () => {
            self.router.navigate(['/account/login']);
            observer.next(false);;
        });
        return observable;
    }
};


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/services/SecurityServices/permission.service.ts